import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";

export const useCustomerInfoEdit = () => {
  const dispatch = useDispatch();
  const { navigateToMyPage } = useNavigation();

  const handleCustomerInfoEdit = useCallback(
    (
      name: string,
      phoneNumber: string,
      password: string,
      passwordConfirmation: string,
    ) => {
      dispatch(appActions.showLoading());
      dispatch(
        authActions.editUserInformation.started({
          name,
          tel: phoneNumber,
          password,
          password_confirmation: passwordConfirmation,
          // TODO: change to selected language
          lang: "ja",
          onComplete: () => dispatch(appActions.hideLoading()),
          onSuccess: () =>
            dispatch(
              appActions.showModal.started({
                title: "ユーザー情報を更新しました。",
                nextButtonLabel: "閉じる",
                handleNext: () => {
                  dispatch(appActions.closeModal());
                  navigateToMyPage();
                },
              }),
            ),
        }),
      );
    },
    [],
  );

  return { handleCustomerInfoEdit };
};
